//IMPORTANTE ES LA CANTIDAD DE PASOS DEL ONBOARDING
const pasosOnboarding = 12;

const countNodesInLine = (nodes, line) => {
  return nodes.filter((node) => node.line === line).length;
};

let containerWidth = 1400;

if (pasosOnboarding > 8) containerWidth = 1500;

export const setNodesPosition = (nodes) => {
  const line1Count = Math.min(countNodesInLine(nodes, 1), pasosOnboarding);
  const line2Count = Math.min(countNodesInLine(nodes, 2), 1);
  const line3Count = Math.min(countNodesInLine(nodes, 3), 16);

  let nodeWidth = 200;

  if (nodes.length > 10) nodeWidth = 150;

  const line1Width = line1Count * nodeWidth;
  const line2Width = line2Count * nodeWidth;
  const line3Width = line3Count * nodeWidth;

  let variable = 0;

  if (line1Count >= 3) variable = 1;
  if (line1Count < 3) variable = 0;
  if (line1Count === 1) variable = -1;

  const line1Offset = (containerWidth - line1Width) / (line1Count - variable);
  const line2Offset = (containerWidth - line2Width) / 12;
  const line3Offset = (containerWidth - line3Width) / 12;

  return nodes.map((node) => {
    if (node.line === 1) {
      const line1Nodes = nodes
        .filter((n) => n.line === 1)
        .slice(0, pasosOnboarding);
      const nodeIndexInLine1 = line1Nodes.indexOf(node);
      return {
        ...node,
        position: { x: line1Offset + nodeIndexInLine1 * nodeWidth, y: 0 },
      };
    }

    if (node.line === 2) {
      const nodeIndexInLine2 = 0;
      return {
        ...node,
        position: { x: line2Offset + nodeIndexInLine2 * nodeWidth, y: 150 },
      };
    }

    if (node.line === 3) {
      const nodeIndexInLine3 = 0;
      return {
        ...node,
        position: { x: line3Offset + nodeIndexInLine3 * nodeWidth, y: 300 },
      };
    }

    // if (node.line === 3) {
    //   const line3Nodes = nodes.filter((n) => n.line === 3).slice(0, 14);
    //   const nodeIndexInLine3 = line3Nodes.indexOf(node);
    //   return {
    //     ...node,
    //     position: {
    //       x: line3Offset + nodeIndexInLine3 * nodeWidth,
    //       y: 300,
    //     },
    //   };
    // }

    return node;
  });
};
